<template>
	<CommonFlame :title="title">
		<v-sheet elevation="0">
			<div class="table-container mt-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="categories"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>
								{{ `[${item.keyword}] ${item.name}` }}
							</td>
							<td>
								{{ picUser(item.id) ? picUser(item.id).full_name : "未設定" }}
							</td>
							<td v-if="authority_flag" class="pa-1">
								<v-row no-gutters justify="space-around" align="center">
									<v-btn color="secondary" @click="openEditDialog(item)">
										<v-icon class="mr-1">mdi-pencil</v-icon>
										編集
									</v-btn>
								</v-row>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-sheet>
		<ProductCategoryUserEditDialog
			:dialog.sync="editDialog"
			:category="selectedCategory"
			:users="users"
			:productCategoryUser="productCategoryUser"
			@update-product-category-user="updateProductCategoryUser($event)"
			@create-product-category-user="createProductCategoryUser($event)"
		/>
	</CommonFlame>
</template>

<script>
import errorHandling from "../../helper/errorHandling"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import CommonFlame from "../shared/CommonFlame.vue"
import ProductCategoryUserEditDialog from "./components/ProductCategoryUserEditDialog.vue"

export default {
	components: {
		CommonFlame,
		ProductCategoryUserEditDialog,
	},
	data() {
		return {
			authority_flag: false,
			editDialog: false,
			selectedCategory: {},
			productCategoryUser: {},
			categories: [],
			users: [],
			product_category_users: [],
			title: "分類別担当者設定",
		}
	},

	mounted() {
		this.fetchProductCategoryUsers()
	},

	methods: {
		fetchProductCategoryUsers() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/quality_assurances/product_category_users", { headers })
				.then((res) => {
					this.categories = res.data.categories
					this.users = res.data.users
					this.product_category_users = res.data.product_category_users
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openEditDialog(category) {
			this.selectedCategory = category
			this.productCategoryUser = this.product_category_users.find(
				(u) => u.product_category_id === category.id
			)
			this.editDialog = true
		},
		picUser(category_id) {
			const product_category_user = this.product_category_users.find(
				(u) => u.product_category_id === category_id
			)
			if (product_category_user)
				return this.users.find((u) => u.id === product_category_user.user_id)
		},
		updateProductCategoryUser(productCategoryUser) {
			const index = this.product_category_users.findIndex((p) => p.id === productCategoryUser.id)
			this.product_category_users.splice(index, 1, productCategoryUser)
		},
		createProductCategoryUser(productCategoryUser) {
			this.product_category_users.push(productCategoryUser)
		},
  },
  computed:{
		headers() {
			if (this.authority_flag) {
				return [
					{ text: "分類", value: "name", width: "100px" },
					{ text: "担当者", value: "full_name", width: "200px" },
					{ text: "", value: "", width: "100px" },
				]
			} else {
				return [
					{ text: "分類", value: "name", width: "100px" },
					{ text: "担当者", value: "full_name", width: "200px" },
				]
			}
		},
	},
}
</script>